import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiKey } from "../../../config/config";
import { languageHelper } from "../../../config/helperFunctions";

function AddSocialMedia() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [icon, setIcon] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    let formData = new FormData();

    formData.append("name", name);
    formData.append("link", link);
    formData.append("status", "active");
    if (icon) {
      formData.append("icon", icon);
    }

    axios
      .post(`${apiKey}/api/rms/admin/socialmedia`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Successfully added social media link", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setLoading(false);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Failed to add social media link"
        );
        setLoading(false);
      });
  };

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">
            {languageHelper("Add Social Media")}
          </h1>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="md:grid grid-cols-2 gap-4">
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="name"
                    onChange={(e) => setName(e.target.value)}
                    placeholder={languageHelper("Name")}
                    value={name}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Link")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="link"
                    onChange={(e) => setLink(e.target.value)}
                    value={link}
                    placeholder={languageHelper("Link")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2">
                  {languageHelper("Icon")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/jpg"
                    onChange={(e) => setIcon(e.target.files[0])}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddSocialMedia;
